import { initialState } from "./selectors";
import { GET_BRANDS_REQUEST, GET_BRANDS_SUCCESS } from "./actions";

export default function brand(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case GET_BRANDS_REQUEST:
      return {
        ...state,
        brands: [],
      };
    case GET_BRANDS_SUCCESS:
      return {
        ...state,
        brands: payload,
      };
    default:
      return state;
  }
}
